// extracted by mini-css-extract-plugin
export default {"wrapper":"date-table-cell_wrapper__S+wt2"};